import { Grid, InputWrapper, Text } from '@mantine/core'
import { referenceDisplay } from '@seen/core/display'
import type { SDR } from '@seen/core/models/tasks/sdr/sdr'
import type { JSX } from 'react'
import { DateDisplay } from '#src/components/display/DateTimeDisplay.tsx'

type Props = {
  sdr: SDR
}

export function SDRIDTReviewResult({ sdr }: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <Text className="text-lg font-semibold">Review Result</Text>

      <Grid>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <InputWrapper label="Review Date" className="grow">
            {sdr.reviewDate ? (
              <DateDisplay element={Text} value={sdr.reviewDate} />
            ) : (
              <Text>N/A</Text>
            )}
          </InputWrapper>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <InputWrapper label="Informed Method" className="grow">
            <Text>{sdr.reviewInformedMethod}</Text>
          </InputWrapper>
        </Grid.Col>
      </Grid>

      {sdr.reviewNotes?.length && (
        <InputWrapper label="Notes" className="grow">
          <Text>{sdr.reviewNotes ?? 'No notes provided'}</Text>
        </InputWrapper>
      )}

      <InputWrapper label="Reviewed by" className="grow">
        <Text>{referenceDisplay(sdr.reviewInvolvedIDTMember)}</Text>
      </InputWrapper>
    </div>
  )
}
